export default __webpack_public_path__ + "static/media/pouf2.1b4a5e0b.JPG";